import axios, { AxiosInstance, AxiosRequestConfig } from "axios";

export const getToken = async () => {
  try {
    return (await window.localStorage.getItem("AUTH_TOKEN")) || "";
  } catch (e) {
    console.log("getToken", e)
  }
};

export const getRefreshToken = async () => {
  try {
    return (await window.localStorage.getItem("REFRESH_TOKEN")) || "";
  } catch (e) {
    console.log("getRefreshToken", e)
  }
};

export const refresh_token = async () => {
  try {
    const result = await CoreApi.post(
      "refresh-auth-token",
      {
        refreshToken: await getRefreshToken(),
      }
    );
    return result;
  } catch (error) {
    console.error("http refresh_token error", error);
    throw error;
  }
};

const updateAuthToken = (token : any) => {
  localStorage.setItem("AUTH_TOKEN", token);
};

let REACT_APP_API_URL = process.env.REACT_APP_API_URL;

let instance: AxiosInstance = axios.create();
let multiPartInstance: AxiosInstance = axios.create();

let refreshing_token : any = null;

//Axios Instance
export const Http = {
  createInstance: (baseUrl: string): AxiosInstance => {
    // Axios instance
    instance = axios.create({
      baseURL: baseUrl,
      headers: {
        "Content-Type": "application/json",
        "application-key": 'b1945821-01a8-482f-9951-0e65a3d844e6',
      },
    });

    // Request interceptor
    instance.interceptors.request.use(async (config) => {
      config.headers.set("x-token", await getToken());
      return config;
    });

    // Response interceptor
    instance.interceptors.response.use(
      (response) => response.data,
      async (error) => {
        const config = error.config;
        console.log("error.response", error.response);

        if (error.response && error.response.status === 401 && !config._retry) {
          config._retry = true;
          try {
            refreshing_token = refreshing_token
              ? refreshing_token
              : refresh_token();
            let res: any = await refreshing_token;
            refreshing_token = null;
            if (res?.data?.authorizationToken) {
              updateAuthToken(res?.data?.authorizationToken);
            }
            return instance(config);
          } catch (err) {
            // redirect to security login
            localStorage.clear();
            window.location.href = "/";;
            // return Promise.reject(err);
          }
        } else if (
          error.response &&
          error.response.status === 403 &&
          error.response?.data?.message
            ?.toLowerCase()
            .includes("unauthorized access")
        ) {
          // Redirect to access denied page
          window.location.href = "/access-denied";
        }

        return Promise.reject(error.response);
      }
    );

    return instance;
  },

  /**
   * Set HTTP custom header
   *
   * @param name
   * @param value
   */
  setHeader: (name: string, value: string) => {
    instance.defaults.headers.common[name] = value;
  },
};


// HTTP Client
export const HttpMultiPart = {
  createInstance: (baseUrl: string): AxiosInstance => {
    // Axios instance
    multiPartInstance = axios.create({
      baseURL: baseUrl,
      headers: {
        "Content-Type": "multipart/form-data",
        "application-key": 'b1945821-01a8-482f-9951-0e65a3d844e6'
      },
    });

    // Request interceptor
    multiPartInstance.interceptors.request.use(async (config) => {
      config.headers.set("X-TOKEN", await getToken());
      config.headers.set("Content-Type", "multipart/form-data");
      config.headers.set("Accept", "multipart/form-data");
      return config;
    });

    // Response interceptor
    multiPartInstance.interceptors.response.use(
      (response) => response.data,
      async (error) => {
        const config = error.config;
        return Promise.reject(error.response);
      }
    );

    return multiPartInstance;
  },

  /**
   * Set HTTP custom header
   *
   * @param name
   * @param value
   */
  setHeader: (name: string, value: string) => {
    multiPartInstance.defaults.headers.common[name] = value;
  },
};

export const http = {
  /**
   * Send HTTP GET request
   *
   * @param url
   * @param config
   * @returns
   */
  get: (url: string, config?: AxiosRequestConfig) => instance.get(url, config),

  /**
   * Send HTTP POST request
   *
   * @param url
   * @param data
   * @param config
   * @returns
   */
  post: (url: string, data?: any, config?: AxiosRequestConfig) =>
    instance.post(url, data, config),

  /**
   * Send HTTP PUT request
   *
   * @param url
   * @param data
   * @param config
   * @returns
   */
  put: (url: string, data?: any, config?: AxiosRequestConfig) =>
    instance.put(url, data, config),

  /**
   * Send HTTP PATCH request
   *
   * @param url
   * @param data
   * @param config
   * @returns
   */
  patch: (url: string, data?: any, config?: AxiosRequestConfig) =>
    instance.patch(url, data, config),

  /**
   * Send HTTP DELETE request
   *
   * @param url
   * @param config
   * @returns
   */
  delete: (url: string, config?: AxiosRequestConfig) =>
    instance.delete(url, config),
};

export const multiPartHttp = {
  /**
   * Send HTTP POST request
   *
   * @param url
   * @param data
   * @param config
   * @returns
   */
  post: (url: string, data?: any, config?: AxiosRequestConfig) =>
    multiPartInstance.post(url, data, config),
};

export const CoreApi = Http.createInstance(REACT_APP_API_URL || "");

export const MultiPartApi = HttpMultiPart.createInstance(
  REACT_APP_API_URL || ""
);
